export default "__VITE_ASSET__38764f00__"